// extracted by mini-css-extract-plugin
export var blink = "Endpoint-module--blink--bd653";
export var examples = "Endpoint-module--examples--3fea5";
export var gradient = "Endpoint-module--gradient--190ac";
export var reference = "Endpoint-module--reference--43b82";
export var spin = "Endpoint-module--spin--e0261";
export var summary = "Endpoint-module--summary--933c8";